import { Choice } from '../models/choice';

export const unitsOfMeasure: Choice[] = [
    { value: 'EA', label: 'Pieces/Units' },
    { value: 'CY', label: 'Clean Yield' },
    { value: '3 MI', label: '3 Thousand Square Inches' },
    { value: 'CYD', label: 'Cubic Yard' },
    { value: 'ADJ', label: 'Adjustments' },
    { value: 'CYG', label: 'Clean Yield Gram' },
    { value: 'B56', label: '56 Pound Bushel' },
    { value: 'CYK', label: 'Clean Yield Kilogram' },
    { value: 'BBL', label: 'Barrel' },
    { value: 'DEG', label: 'Degree' },
    { value: 'BFT', label: 'Board Feet' },
    { value: 'DOZ', label: 'Dozen' },
    { value: 'BTU', label: 'British Thermal Unit' },
    { value: 'DPC', label: 'Dozen Pieces' },
    { value: 'BU', label: 'Bushel' },
    { value: 'DPR', label: 'Dozen Pair' },
    { value: 'C', label: 'One Hundred or Celsius' },
    { value: 'CAR', label: 'Carat' },
    { value: 'F', label: 'Fahrenheit' },
    { value: 'CD', label: 'Cord' },
    { value: 'FT', label: 'Feet' },
    { value: 'CFT', label: 'Cubic Foot/Feet' },
    { value: 'G', label: 'Grams' },
    { value: 'CG', label: 'Centigrams' },
    { value: 'GAL', label: 'Gallon' },
    { value: 'CGM', label: 'Content Gram' },
    { value: 'GR', label: 'Gross' },
    { value: 'CKG', label: 'Content Kilogram' },
    { value: 'GRL', label: 'Gross Lines' },
    { value: 'CLB', label: 'Content Pound' },
    { value: 'GRM', label: 'Gram' },
    { value: 'CLF', label: 'One Hundred Leaves' },
    { value: 'GRO', label: 'Gross' },
    { value: 'CM', label: 'Centimeter' },
    { value: 'HUN', label: 'Hundreds' },
    { value: 'CM3', label: 'Cubic Centimeters' },
    { value: 'HZ', label: 'Hertz' },
    { value: 'CRT', label: 'Crate' },
    { value: 'JWL', label: 'Jewels' },
    { value: 'CSI', label: '100 Square Inches' },
    { value: 'K', label: '1,000' },
    { value: 'CTN', label: 'Content Ton' },
    { value: 'KG', label: 'Kilogram' },
    { value: 'CUR', label: 'Curie' },
    { value: 'KGM', label: 'Kilogram' },
    { value: 'CWT', label: 'Hundred Weight' },
    { value: 'KHZ', label: 'Kilohertz MBQ Megabacquerel' },
    { value: 'KM', label: '1,000 Meters MC Millicurie' },
    { value: 'KM2', label: '1,000 Square Meters MCF Thousand Cubic Feet' },
    { value: 'KM3', label: '1,000 Cubic Meters MET Meters' },
    { value: 'KN', label: 'Kilo Newton MFT Thousand Feet' },
    { value: 'KPA', label: 'Kilopascal MG Milligram' },
    { value: 'KSB', label: '1,000 Standard Brick ML Milliliter' },
    { value: 'KW', label: 'Kilowatts MLF Thousand Linear Feet' },
    { value: 'KWH', label: 'Kilowatt-hours MPA Millipascal' },
    { value: 'L', label: 'Liter MSF Thousand Square Feet' },
    { value: 'LB', label: 'Pound MSI Thousand Square Inches' },
    { value: 'LBC', label: 'Pound Including Container MYD Thousand Yards' },
    { value: 'LF', label: 'Leaf NO Number' },
    { value: 'LFT', label: 'Linear Foot OZ Ounces' },
    { value: 'LIN', label: 'Linear PAR Pair' },
    { value: 'LNM', label: 'Linear Meters PC Piece' },
    { value: 'LTR', label: 'Liters PCS Pieces' },
    { value: 'LYD', label: 'Linear Yard PFG Proof Gallon' },
    { value: 'M', label: 'Meters PFL Proof Liter' },
    { value: 'M2', label: 'Square Meters PK Pack (Cards)' },
    { value: 'M3', label: 'Cubic Meters PR Pair' },
    { value: 'MBE', label: 'Thousand Std Brick Equivalent PRS Pair or Pairs' },
    { value: 'MBF', label: 'Thousand Board Feet PSI Pounds Per Square Inch' },
    { value: 'QT', label: 'Quart STN Short Ton' },
    { value: 'ROL', label: 'Roll SYD Square Yard' },
    { value: 'SBE', label: 'Standard Brick Equivalent TOZ Troy Ounce' },
    { value: 'SFT', label: 'Square Foot X Quantity Not Required' },
    { value: 'SQ', label: 'Square(s) YD Yard' },
    { value: 'SQI', label: 'Square Inch YN Yarn' }
];

